import React, { useCallback, useContext } from "react";
import { ShowSuccessPopup, translate } from "clavis-nxt-components-custdevtm";
import { ModuleConfigContext } from "../../ModuleConfigContext/ModuleConfigContext";
import { LogOutQuestionModal } from "../LogOutQuestionModal/LogOutQuestionModal";
import "./User.scss";

/** Get gatekeeper config from context.
 *  @param {?Object} context - Context object.
 *  @return {?Object} */

const User = props => {
  const moduleConfigContext = useContext(ModuleConfigContext);
  const { t } = props;

  /** Memoized logout with context function. */
  const memoizedOnClickLogout = useCallback(() => {
    ShowSuccessPopup(
      t("platform.logout.logOutTitle"),
      null,
      {
        container: "user",
        content: "logout-modal-container"
      },
      <LogOutQuestionModal moduleConfigContext={moduleConfigContext} />,
      "question"
    );
  }, [moduleConfigContext]);

  return (
    <div className="user">
      <i className="icon-small icon-user" />
      <div className="user-data">
        <div className="username normal-font-bold">
          {sessionStorage.getItem("clavis.username")}
        </div>
      </div>
      <i className="icon-small icon-logout" />
      <div className="user-data">
        <div
          className="username logout-cursor normal-font-bold"
          onClick={memoizedOnClickLogout}
        >
          {t("platform.User.logout")}
        </div>
      </div>
    </div>
  );
};

export default translate()(User);
